const imsrVersion = {
  version: "v26.01.0",
  updateDate: "2026/01/26",
  expireDays: 14
};

export default imsrVersion;
